import { searchJmesPath } from '../../../utils/jmespath';
import type { ConditionExpression } from './types';

const CONDITION_REGEX = /^(.+?)\s*(==|!=|>=|<=|>|<)\s*(.+)$/;

export function parseCondition(expression: string): ConditionExpression {
  const trimmed = expression.trim();

  // Negation: !field
  if (trimmed.startsWith('!')) {
    return { lhs: trimmed.slice(1).trim(), operator: 'falsy' };
  }

  // Comparison operators
  const match = trimmed.match(CONDITION_REGEX);
  if (match) {
    const [, lhs, operator, rawRhs] = match;
    const trimmedRhs = rawRhs.trim();

    let rhs: string | number;
    if (/^["'].*["']$/.test(trimmedRhs)) {
      rhs = trimmedRhs.slice(1, -1);
    } else if (!isNaN(Number(trimmedRhs))) {
      rhs = parseFloat(trimmedRhs);
    } else {
      rhs = trimmedRhs;
    }

    return {
      lhs: lhs.trim(),
      operator: operator as ConditionExpression['operator'],
      rhs,
    };
  }

  // Simple truthiness: field
  return { lhs: trimmed, operator: 'truthy' };
}

export function evaluateCondition(
  expr: ConditionExpression,
  context: object
): boolean {
  const lhsValue = searchJmesPath(context, expr.lhs);
  const rhs = expr.rhs;

  switch (expr.operator) {
    case 'truthy':
      return lhsValue != null && lhsValue !== '' && lhsValue !== false;
    case 'falsy':
      return lhsValue == null || lhsValue === '' || lhsValue === false;
    case '==':
      // eslint-disable-next-line eqeqeq
      return lhsValue == rhs;
    case '!=':
      // eslint-disable-next-line eqeqeq
      return lhsValue != rhs;
    case '>':
      return Number(lhsValue) > Number(rhs);
    case '<':
      return Number(lhsValue) < Number(rhs);
    case '>=':
      return Number(lhsValue) >= Number(rhs);
    case '<=':
      return Number(lhsValue) <= Number(rhs);
  }
}
